import audioController from '../lib/audioController'
import uniqid from 'uniqid'
import alert from '@/lib/alert' 

export default {
  namespaced: true,
  state: {
    playing: false,
    recording: false,
    stopFunction: null
  },
  mutations: {
    START_PLAYING: (state, id) => {
      state.playing = id;
    },
    STOP_PLAYING: (state) => {
      state.playing = false;
    },
    START_RECORDING: (state) => {
      state.recording = true;
    },
    STOP_RECORDING: (state) => {
      state.recording = false;
    }
  },
  actions: {
    playerPlay: ({commit, state}, {type, payload}) => {
      const id = uniqid();
      return new Promise((resolve, reject) => {
        if(type == 'bot') {
          if(window.speechSynthesis) {
            commit('START_PLAYING', id);
            audioController.ttsSpeak(payload).then(() => {
              if(state.playing == id) { commit('STOP_PLAYING') }
              resolve();
            }).catch(err => {
              if(state.playing == id) { commit('STOP_PLAYING') }
              reject(err);
            })
          } else {
            reject('Browser not supporting TTS')
          }
        } else {
          commit('START_PLAYING', id);
          audioController.recorderPlay(payload).then(() => {
            commit('STOP_PLAYING');
            resolve();
          }).catch(err => {
            commit('STOP_PLAYING');
            reject(err);
          })
        }
      })
    },
    playerStop: ({commit, state}) => {
      if(window.speechSynthesis) { 
        window.speechSynthesis.cancel()
      }
      if(state.playing) {
        audioController.audioStop();
        commit('STOP_PLAYING');
      }
    },
    playerRecordingStart: ({commit}) => {
      return new Promise((resolve, reject) => {
        audioController.recorderStart().then(() => {
          commit('START_RECORDING');
          resolve();
        }).catch(err => {
          if(err == 'Requested device not found') {
            alert.showError('Audio device not found');
          } else if(err == 'Permission denied') {
            alert.showError('No permission to use the microphone');
          } else {
            alert.showError('Unknown Error');
          } 
          reject(err);
        })
      })
    },
    playerRecordingStop: ({commit}) => {
      return new Promise((resolve, reject) => {
        audioController.recorderStopRecording().then(data => {
          commit('STOP_RECORDING');
          resolve(data);
        }).catch(err => {
          commit('STOP_RECORDING');
          reject(err);
        })
      })
    }
  },
  getters: {
    playingState: (state) => {
      return state.playing;
    },
    recordingState: (state) => {
      return state.recording;
    }
  }
}